import React from "react"

import Board_GroupBy from "../../../../managers/group-by/group-by"
import Board_Manager from "../../../../managers/manager"
import FieldsFactory from "../../../../../../../fields3/fields-factory"
import {FieldType} from "../../../../../../../fields3/field-type"
import FieldSelectField from "../../../../../../../fields3/generic/select/select-field/select-field"
import FieldFormElementView from "../../../../../../../fields3/render/form-elemnent-view"
import {useForceUpdate} from "../../../../../../../gd/utils/dom-and-react/react-utils"
import {LifecycleAction} from "../../../../../../../gd/const/lifecycle"
import {AggregateFunctionName, AggregateFunctionType} from "../../../../../../../data-structures/aggregators/types"
import Board_Settings from "../../../../managers/settings/settings"

type Props = {
    className?  : string

    manager     : Board_Manager
}

// const debug = "Board_ShowTotal_OptionColumns"
const debug = false

export default function Board_ShowTotal_OptionColumns(props: Props) {

    const forceUpdate = useForceUpdate()

    const groupBy = props.manager.groupBy as Board_GroupBy

    if (groupBy.isSingleColumn) {
        return null
    }

    const settings = props.manager.settings as Board_Settings

    const onChangeField = async (fieldId?: string) => {
        debug && console.log(debug, 'onChangeField', fieldId)

        if (fieldId) {
            const aggregateField = props.manager.fields.get(fieldId)

            const availableAggregateFunctions: AggregateFunctionType[] = aggregateField.getAggregateOptions()
            let aggregateFunction
            // leave current aggregate function if it is available for new field
            if (availableAggregateFunctions.includes(settings.columnsAggregate?.function!)) {
                aggregateFunction = settings.columnsAggregate?.function
            } else {
                aggregateFunction = aggregateField.getDefaultAggregateFunction() || availableAggregateFunctions[0]
            }

            settings.columnsAggregate = {
                fieldId     : fieldId,
                function    : aggregateFunction
            }
        } else {
            settings.columnsAggregate = undefined
        }


        const reloaded = await props.manager.checkRequiredFieldsAndReload()

        if (!reloaded) {
            // recalculate children and rerender
            props.manager.update([
                LifecycleAction.PROCESS_DATA,
                LifecycleAction.RENDER,
            ])
        }

        forceUpdate()
    }

    const onChangeFunction = (value?: AggregateFunctionType) => {
        if (!settings.columnsAggregate) {
            return
        }

        debug && console.log(debug, 'onChangeFunction', value)

        const columnsAggregate = _.cloneDeep(settings.columnsAggregate)
        columnsAggregate.function = value
        settings.columnsAggregate = columnsAggregate

        // recalculate children and rerender
        props.manager.update([
            LifecycleAction.PROCESS_DATA,
            LifecycleAction.RENDER,
        ])

        forceUpdate()
    }

    const fieldSelector = FieldsFactory.get({
        type                : FieldType.SELECT_FIELD,
        fieldId             : 'fieldId',
        fields              : props.manager.fields,
        fieldsStructure     : props.manager.fields.structureAggregateFields(props.manager.viewType, props.manager.getCustomFields()),
        fieldParams         : {
            keepPopoverOpenOnSelect: true
        },
        noValueOption       : true,
        noValueOptionLabel  : 'Not selected',
    }) as FieldSelectField

    const aggregateField        = settings.columnsAggregate?.fieldId ? props.manager.fields.get(settings.columnsAggregate.fieldId) : undefined
    const aggregateFunctions    = aggregateField?.getAggregateOptions()
    const functionsOptions: Option[] = []
    {_.map(aggregateFunctions, (value: AggregateFunctionType)=>{
        functionsOptions.push({
            value       : value,
            label       : AggregateFunctionName[value as AggregateFunctionType],
            isSelected  : settings.columnsAggregate?.function === value,
        })
    })}

    const fieldFunctionSelector = FieldsFactory.get({
        type                : FieldType.DROPDOWN,
        fieldId             : 'function',
        options             : functionsOptions,
        showMenuMore        : false,
        fieldParams         : {
            keepPopoverOpenOnSelect: true
        },
        noValueOption       : false,
    }) as FieldSelectField

    debug && console.log(debug, 'render', props, settings.columnsAggregate)

    const isAggregateSelected = !!settings.columnsAggregate

    const classes = Classes("border-box min-h-36 p-l-20  p-r-15 p-b-5")

    const selectorsContainerClasses = Classes("flex-row-left-center h-45 ", props.className, {
        'm-t-5': !groupBy.isSingleRow
    })

    const showTitle = groupBy.isRowsAndColumns

    return (
        <div className={classes}>
            <div className="flex-row-left-center w-100p">
                {showTitle &&
                    <div className="flex-row-left-center">
                        <div className="ui5-txt-not-important w-100">Column</div>
                    </div>}

                <div className={selectorsContainerClasses}>
                    <FieldFormElementView
                        className   = "max-w-200 w-200 m-r-8"
                        field       = {fieldSelector}
                        model       = {settings.columnsAggregate}
                        options     = {{
                            attachment          : 'top center',
                            targetAttachment    : 'bottom center'
                        }}
                        onChange    = {onChangeField}
                    />

                    {isAggregateSelected &&
                    <>
                        <FieldFormElementView
                            className   = "max-w-200 w-100 m-r-8"
                            field       = {fieldFunctionSelector}
                            model       = {settings.columnsAggregate}
                            options     = {{
                                attachment          : 'top center',
                                targetAttachment    : 'bottom center'
                            }}
                            onChange    = {onChangeFunction}
                        />
                    </>}
                </div>
            </div>
        </div>
    )
}